import { formatPriorityToken } from "~/components/command-center/taskRowFormatting";
import { cn } from "~/lib/utils";

/** Compact priority token (P0..P3). Color only for critical; neutral stays muted. */
export function TaskPriorityToken({ priority }: { priority: string | null }) {
  const token = formatPriorityToken(priority);
  if (!token) return null;
  return (
    <span
      className={cn(
        "text-[11px] font-medium tabular-nums",
        token.tone === "critical" ? "text-warning-foreground" : "text-muted-foreground",
      )}
    >
      {token.label}
    </span>
  );
}
